import { dataWithPath } from '../common/utils'
import _ from 'lodash'

export const moduleFactory = (arr, api, cached, addState = {}, addMutations = {}, addActions = {}) => {
  const state = { ...addState }
  const mutations = { ...addMutations }
  const actions = { ...addActions }
  for (var index = 0; index < arr.length; index++) {
    var item = arr[index]
    state[item[1]] = {}
    if (!mutations[item[0]]) {
      mutations[item[0]] = (([action, dataKey, responseKey, subDataKey, dataParse]) => (state, payload) => {
        !dataParse && (dataParse = data => data)
        const currentPage = dataWithPath(payload, 'params.page')
        if (subDataKey) { // 如果需要根据参数分别存储请求结果
          const key = parseParamsKey(payload.params, subDataKey)
          if (currentPage > 1) {
            state[dataKey] = { ...state[dataKey], [key]: _.mergeWith(state[dataKey][key], dataWithPath(payload, responseKey), customizer) }
          } else {
            state[dataKey] = { ...state[dataKey], [key]: dataWithPath(payload, responseKey) }
          }
        } else if (currentPage >= 1) { // 如果需要分页
          if (currentPage === 1) {
            state[dataKey] = dataWithPath(payload, responseKey)
          } else {
            state[dataKey] = _.mergeWith(state[dataKey], dataWithPath(payload, responseKey), customizer)
          }
        } else {
          state[dataKey] = dataParse(dataWithPath(payload, responseKey))
        }
      })(item)
    }
    actions[item[0]] = (([action, dataKey, responseKey, subDataKey, dataParse]) => (context, params) => {
      const isCached = cached.indexOf(action) !== -1
      if (isCached) {
        let data = state[dataKey]
        if (subDataKey && !_.isEmpty(data)) {
          data = data[parseParamsKey(params, subDataKey)]
          if (!_.isEmpty(data)) {
            return data
          }
        } else if (!_.isEmpty(data)) {
          return data
        }
      }
      return api[action](params).then(
        (response) => {
          context.commit(action, response)// 在commit中根据pagep和size判断如何更新数据
          return Promise.resolve(response)
        },
        (e) => {
          return Promise.reject(e)
        }
      )
    })(item)
  }
  mutations.clear = (state, payload) => {
    state[payload.key] = {}
  }
  return { state, mutations, actions }
}

const parseParamsKey = (params, rule) => {
  let paramsKey = rule.split('+')
  paramsKey = paramsKey.map(function (item) {
    return params[item]
  })
  paramsKey = paramsKey.join('')
  return paramsKey
}

const customizer = function (objValue, srcValue) {
  if (_.isArray(objValue)) {
    return objValue.concat(srcValue)
  }
}
